import { TagEditor } from '@/components/TagTextEditor';
import { Box, Typography } from '@mui/material';
import {
  EditButton,
  SimpleShowLayout,
  useRecordContext,
} from 'react-admin';

export const AIPromptsCommandPanel = ({ isInherited }: { isInherited?: boolean }) => {
  const record = useRecordContext();

  return (
    <Box sx={{ opacity: isInherited ? 0.5 : 1, pointerEvents: isInherited ? 'none' : 'auto' }}>
      <SimpleShowLayout record={record}>
        {!isInherited && <EditButton />}
        <Box component="div">
          <Typography fontWeight="bold">Instruction (Modern)</Typography>
          <TagEditor value={record.instruction || ''} disabled />
        </Box>

        <Box marginTop="2rem" />
        <Box sx={{ opacity: 0.6 }}>
          <Typography variant="caption" color="warning.main" fontWeight="bold">
            DEPRECATED FIELDS (Legacy structure)
          </Typography>
          <Box component="div" marginTop="1rem">
            <Typography fontWeight="bold">System Message (DEPRECATED)</Typography>
            <TagEditor value={record.systemMessage || ''} disabled />
          </Box>

          <Box component="div" marginTop="1rem">
            <Typography fontWeight="bold">Prompt Prepend (DEPRECATED)</Typography>
            <TagEditor value={record.promptPrepend || ''} disabled />
          </Box>

          <Box component="div" marginTop="1rem">
            <Typography fontWeight="bold">Prompt Append (DEPRECATED)</Typography>
            <TagEditor value={record.promptAppend || ''} disabled />
          </Box>
        </Box>
      </SimpleShowLayout>
    </Box>
  );
};
